import { api } from '@packages/backend/convex/_generated/api';
import { useQuery } from 'convex-helpers/react';
import { useEffect, useMemo } from 'react';
import { WorldlinePaymentCallback } from './WorldlinePaymentCallback';
import { clearWorldlineRedirectState, getWorldlineRedirectState } from './worldlineRedirectState';

type SessionWorldlinePaymentCallbackProps = {
  sessionUuid: string;
  paymentIdFromUrl?: string;
  onSuccess: () => void;
  onBack: () => void;
};

export const SessionWorldlinePaymentCallback = ({
  sessionUuid,
  paymentIdFromUrl,
  onSuccess,
  onBack,
}: SessionWorldlinePaymentCallbackProps) => {
  const paymentGatewayPaymentId = useMemo(() => {
    if (paymentIdFromUrl) {
      return paymentIdFromUrl;
    }

    const redirectState = getWorldlineRedirectState(sessionUuid);
    return redirectState?.paymentGatewayPaymentId ?? null;
  }, [paymentIdFromUrl, sessionUuid]);

  const { data: session } = useQuery(api.sessions.getSessionX, { sessionUuid });

  const paymentRecorded = useMemo(() => {
    if (!session || !paymentGatewayPaymentId) {
      return false;
    }

    return session.payments.some(
      (payment) => payment.paymentGatewayPaymentId === paymentGatewayPaymentId,
    );
  }, [paymentGatewayPaymentId, session]);

  useEffect(() => {
    if (paymentRecorded) {
      clearWorldlineRedirectState(sessionUuid);
    }
  }, [paymentRecorded, sessionUuid]);

  return (
    <WorldlinePaymentCallback
      paymentGatewayPaymentId={paymentGatewayPaymentId}
      paymentRecorded={paymentRecorded}
      onSuccess={onSuccess}
      onBack={onBack}
    />
  );
};
